import script from "./ManufacturerInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ManufacturerInfo.vue?vue&type=script&setup=true&lang=js"

import "./ManufacturerInfo.vue?vue&type=style&index=0&id=0c6084f3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c6084f3"]])

export default __exports__